import React, { useState, useEffect } from 'react';
import PubSub from 'pubsub-js';

import AccountNavDialogV2 from '../AccountNavDialogV2/AccountNavDialogV2';

const AccountNavDialogContainer = (props) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const openToken = PubSub.subscribe('account_nav.open', () => {
      setIsOpen(true);
    });

    const closeToken = PubSub.subscribe('account_nav.close', () => {
      setIsOpen(false);
    });

    return () => {
      PubSub.unsubscribe(openToken);
      PubSub.unsubscribe(closeToken);
    };
  }, []);

  return (
    <AccountNavDialogV2
      isOpen={isOpen}
      onRequestClose={() => setIsOpen(false)}
      {...props}
    />
  );
};

export default AccountNavDialogContainer;
